import React from 'react';
import { LocalizationContext } from '../../../hoc/Localization';
import usePriceFormat from '../../../utils/priceFormat';
import styles from './styles.less';

interface PricePropsInterface {
    course: any;
    showMonthlyPrice: boolean;
    isEditMode?: boolean;
    isSearchMode?: boolean;
}

const Price: React.FC<PricePropsInterface> = ({
    course,
    showMonthlyPrice,
    isEditMode = false,
    isSearchMode = false,
}) => {
    const { t } = React.useContext(LocalizationContext);

    const { currency, period, monthly_price: monthlyPrice, period_value: periodValue } = course;

    const symbolCurrency = {
        AMD: '֏',
        USD: '$',
        EUR: '€',
        RUB: '₽',
    };

    const { priceFormat, getCoursePrice } = usePriceFormat();

    const { initial, discount, isFreeCourse } = getCoursePrice(course);

    let currentPeriod = '';

    if (period && period !== 'custom') {
        currentPeriod = t(`course.details.content.${period}`);
    }
    if (period && period === 'custom') {
        currentPeriod = periodValue;
    }

    let Content = null;

    if (isFreeCourse) {
        Content = (
            <>
                <span className={styles.generalPrice}>{t('details.course.free')}</span>
            </>
        );
    } else if (discount.amount) {
        Content = (
            <>
                <div className={styles.discountedPrice}>
                    <span className={styles.perPrice}>
                        {`${priceFormat(initial.price)} ${symbolCurrency[currency]}`}
                    </span>
                    <span>
                        <span className={styles.generalPrice}>
                            {`${priceFormat(discount.price)} ${symbolCurrency[currency]}`}
                            <div className={styles.currentPeriodPos}>{currentPeriod}</div>
                        </span>
                    </span>
                </div>
            </>
        );
    } else if (initial.price) {
        Content = (
            <>
                <span className={styles.generalPrice}>
                    {`${priceFormat(initial.price)} ${symbolCurrency[currency]}`}
                </span>
                <div className={styles.currentPeriodPos}>{currentPeriod}</div>
                {showMonthlyPrice && !!monthlyPrice && monthlyPrice !== initial.price && (
                    <>
                        <div className={styles.monthlyPrice}>
                            <span className={styles.generalPrice}>
                                ~{`${priceFormat(monthlyPrice)} ${symbolCurrency[currency]}`}
                            </span>
                            <span className={styles.perPrice}>
                                {t('course.details.content.month')}
                            </span>
                        </div>
                    </>
                )}
            </>
        );
    } else {
        Content = (
            <>
                <span className={styles.generalPrice}>N/A</span>
                <span className={styles.perPrice}>{t('course.details.no.price')}</span>
            </>
        );
    }

    return (
        <div
            className={`${styles.priceContainer} ${isEditMode ? styles.editMode : ''} ${
                isSearchMode ? styles.searchMode : ''
            }`}
        >
            {Content}
        </div>
    );
};

export default Price;
